// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup__b9sNp","container":"styles_container__QJIu9","close":"styles_close__nwa7K"};